// src/main.jsx
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/base.css';
import './styles/legacy.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes.jsx';

import { initAnalytics } from './analytics';

const GA_DEBUG = import.meta.env.VITE_GA_DEBUG === 'true';

if (import.meta.env.PROD || GA_DEBUG) {
  initAnalytics();
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </React.StrictMode>
);
